import type { MapRegion } from '../../types';

interface RegionLegendProps {
  regions: MapRegion[];
  selectedRegionId: string | null;
  onRegionSelect: (regionId: string | null) => void;
}

export default function RegionLegend({ regions, selectedRegionId, onRegionSelect }: RegionLegendProps) {
  if (regions.length === 0) return null;

  const handleClick = (regionId: string) => {
    // Toggle: click same region to deselect
    onRegionSelect(selectedRegionId === regionId ? null : regionId);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-3 mb-4 flex flex-wrap gap-3 items-center">
      <span className="text-sm font-medium text-gray-600 dark:text-gray-400 mr-1">Regions:</span>
      {regions.map((region) => {
        const isSelected = selectedRegionId === region.id;
        const isDimmed = selectedRegionId !== null && !isSelected;

        return (
          <button
            key={region.id}
            onClick={() => handleClick(region.id)}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-sm font-medium transition-all border ${
              isSelected
                ? 'border-gray-400 dark:border-gray-500 bg-gray-100 dark:bg-gray-700 shadow-sm'
                : isDimmed
                ? 'border-transparent opacity-40'
                : 'border-transparent hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          >
            <span
              className="w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: region.color }}
            />
            <span className="text-gray-700 dark:text-gray-300">{region.name}</span>
          </button>
        );
      })}
      {selectedRegionId !== null && (
        <button
          onClick={() => onRegionSelect(null)}
          className="text-xs text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 underline ml-1"
        >
          Clear
        </button>
      )}
    </div>
  );
}
